<button #btnPublish id="btnPublish" (click)="publishLanding()" type="button" class="btn btn-primary btn-icon btn-icon__right btn-publish btn-spinning">
    Publish
    <svg class="icon ic-20"><use href="assets/icons/icons-sprite.svg#svg-publish"/></svg>
</button>